import ScrollReveal from "./ScrollReveal";

const socials = [
  {
    name: "YouTube",
    href: "https://www.youtube.com/c/equilybrapsicologia",
    gradient: "from-red-500/10 to-red-500/5 hover:from-red-500 hover:to-red-600",
    hoverText: "hover:text-primary-foreground",
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/equilybrainsta/",
    gradient: "from-pink-500/10 to-purple-500/5 hover:from-pink-500 hover:to-purple-600",
    hoverText: "hover:text-primary-foreground",
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    href: "https://br.linkedin.com/company/equilybra-clinica-de-psicologia",
    gradient: "from-blue-600/10 to-blue-500/5 hover:from-blue-600 hover:to-blue-700",
    hoverText: "hover:text-primary-foreground",
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
];

const SocialSection = () => {
  return (
    <section className="py-20 bg-background relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-lavender/5 blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <ScrollReveal className="text-center">
          <p className="text-primary font-semibold uppercase tracking-[0.2em] text-sm mb-3">
            Redes Sociais
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground mb-3">
            Siga-nos nas Redes Sociais
          </h2>
          <div className="w-16 h-1 mx-auto mb-4 rounded-full bg-gradient-to-r from-primary to-lavender" />
          <p className="text-muted-foreground mb-12 max-w-md mx-auto">
            Acompanhe nossas dicas e conteúdos sobre saúde mental
          </p>
        </ScrollReveal>

        <div className="flex items-center justify-center gap-8">
          {socials.map((social, i) => (
            <ScrollReveal key={social.name} delay={i * 0.15} scale={0.8}>
              <a
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`w-24 h-24 rounded-3xl flex items-center justify-center transition-all duration-500 shadow-card hover:shadow-soft hover:scale-110 bg-gradient-to-br ${social.gradient} ${social.hoverText} text-foreground/70 backdrop-blur-sm border border-border/50`}
                aria-label={social.name}
              >
                {social.icon}
              </a>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialSection;
